import { BehaviorSubject } from 'rxjs';

export class ListInfo {
  pageData: any[];
  totalRecords: number;
  pageLimit: number;
  private _pageNumber: number;

  constructor(pageData: any, totalRecords: number, pageLimit: number, startPage: number) {
    this.pageData = pageData;
    this.totalRecords = totalRecords;
    this.pageLimit = pageLimit;
    this._pageNumber = startPage;
  }

  get pageNumber(): number {
    return this._pageNumber;
  }

  setPageNumber(page: number) {
    this._pageNumber = page;
  }
}
